export * from '@primeuix/themes/lara/dock';
export { default } from '@primeuix/themes/lara/dock';
